<template>
  <div>
    <el-table @sort-change="changeTableSort" :data="tableData" highlight-current-row border style="width: 100%; margin-top: 39px; margin-bottom: 20px" :empty-text="$t('general.empty_data')">
      <el-table-column sortable="custom" prop="employee_id" :label="$t('general.employee_id')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.employee_id }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empList.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>

      <el-table-column sortable="custom" prop="employee_type" :label="$t('empList.title')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.employee_type }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="500px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-document" @click="handleBasicDeclaration(scope.$index, scope.row)">
            基礎控除/配偶者控除/所得金額調整控除申告</el-button>
          <el-button size="mini" type="success" icon="el-icon-user" @click="jump('/empList')">
            従業員情報変更</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleSortChange">
      </el-pagination>
    </div>

    <!-- 基礎控除/配偶者控除/所得金額調整控除申告 -->
    <el-dialog title="基礎控除/配偶者控除/所得金額調整控除申告" :visible.sync="dialogBasicDeclaration" width="94%" :before-close="handleClose">
      <div align="left" style="margin-top:20px;margin-bottom:39px;float:left;">
        &emsp;社員名:&emsp;{{name}}<br>&emsp;社員番号:&emsp;{{employee_id}}
      </div>
      <div align="right" style="margin-top:20px;margin-bottom:39px;margin-right:139px">
        <el-button class="el-icon-circle-plus-outline" type="primary" size="mini" @click="handleAdd()">{{ $t("general.add") }}
        </el-button>
      </div>

      <el-table v-loading="loading" :data="basicDecData" highlight-current-row border style="width: 100%" :empty-text="$t('general.empty_data')">
        <el-table-column label="年分" align="center" width="100px">
          <template slot-scope="scope">
            <span>{{ scope.row.year }}</span>
          </template>
        </el-table-column>
        <el-table-column label="基礎控除の額" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.basic_d_amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="配偶者控除の額" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.declaration_spouse }}</span>
          </template>
        </el-table-column>
        <el-table-column label="配偶者特別控除の額" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.declaration_special_spouse }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所得金額調整控除" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.requirement }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="350px">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
              {{$t("general.edit")}}</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
              {{$t("general.delete")}}</el-button>
            <el-button size="mini" type="success" icon="el-icon-success" @click="printPDF(scope.$index, scope.row)">
              {{$t("general.print")}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!--add-->
    <el-dialog title="基礎控除/配偶者控除/所得金額調整控除申告書作成" :append-to-body="true" :visible.sync="dialogVisible" width="86%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="210px" class="demo-ruleForm" size="medium" style="margin-left:20px" :label-position="labelPosition">
        <el-input type="hidden" v-model="ruleForm.id" />
        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item label="申告書年分" prop="year">
                <el-select v-model="ruleForm.year" size="mini" placeholder="選択" style="margin-left:10px;width: 200px" clearable>
                  <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('empPDF.name')" prop="name">
                <el-input prefix-icon="el-icon-info" v-model="empListForm.name" size="mini" style="margin-left:10px;width: 200px" :placeholder="$t('empPDF.name')" readonly></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <el-form-item label="記載例" prop="name">
                <el-link style="margin-left:10px;" type="primary" class="el-icon-info" :underline="false" href="https://www.nta.go.jp/taxes/tetsuzuki/shinsei/annai/gensen/pdf/1648_73_03.pdf" target="_blank">控除申告書の記載例はこちら</el-link>
              </el-form-item>

              <el-form-item :label="$t('empPDF.name_frgn')" prop="name_frgn">
                <el-input prefix-icon="el-icon-info" v-model="empListForm.name_frgn" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.name_frgn')" readonly></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <div>
              <el-form-item :label="$t('empPDF.address')" prop="address">
                <el-input :value="empListForm.address1 + empListForm.address2 + empListForm.address3" prefix-icon="el-icon-info" size="mini" style="margin-left:10px;width: 810px" :placeholder="$t('empPDF.address')" readonly></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-collapse>
          <el-collapse-item title="給与所得者の基礎控除申告情報" name="1">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="給与所得（収入金額）" prop="name">
                    <el-input @change="inputIncomeBasic()" v-model="ruleForm.income_year_basic" size="mini" style="margin-left:10px;width: 200px" placeholder="入力してください" clearable></el-input>
                    &nbsp;円
                    <el-popover placement="top-start" title="ヒント:" width="190" trigger="hover" content="給与明細から、年収金額をインポートします。">
                      <el-button @click="inportIncome()" slot="reference" class="el-icon-caret-bottom" type="text">&nbsp;データインポート</el-button>
                    </el-popover>
                  </el-form-item>
                  <el-form-item label="給与所得以外の所得の合計額（所得金額）" prop="name">
                    <el-input @change="total_basicCal()" v-model="ruleForm.income_outside_after_basic" size="mini" style="margin-left:10px;width: 200px" placeholder="入力してください" clearable></el-input>
                    &nbsp;円
                  </el-form-item>
                  <el-form-item label="控除額の計算判定" prop="name">
                    <el-select v-model="ruleForm.judgement_basic" size="mini" placeholder="計算式" style="margin-left:10px;width: 200px" clearable>
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item label="給与所得（所得金額）" prop="name">
                    <el-input v-model="ruleForm.income_after_basic" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                    &nbsp;円
                  </el-form-item>

                  <el-form-item label="あなたの本年中の合計所得金額の見積額" prop="name">
                    <el-input v-model="ruleForm.total_basic" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                    &nbsp;円
                  </el-form-item>

                  <el-form-item label-width="0px" label="" prop="name" size="mini" style="font-weight:bold;color:red;text-align: left;">
                    <span style="font-size: 15px;">基礎控除の額</span>
                    <el-input v-model="ruleForm.basic_d_amount" style="margin-left:125px;width: 185px" readonly="readonly"></el-input>
                    &nbsp;円
                    <el-button @click="basic_d_amountCal()" class="fa fa-calculator" type="text">&nbsp;計算</el-button>
                  </el-form-item>

                  <el-form-item label="区分Ⅰ" prop="name">
                    <el-input v-model="ruleForm.division1" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item title="給与所得者の配偶者控除等申告情報" name="2">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="配偶者氏名" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="empFamilyForm.name_family" size="mini" style="margin-left:10px;width: 200px" readonly="readonly"></el-input>
                    <el-button @click="listFamilySpouse()" class="el-icon-caret-bottom" type="text">情報インポート</el-button>
                  </el-form-item>

                  <el-form-item label="配偶者生年月日" prop="name">
                    <el-date-picker v-model="empFamilyForm.birthday_family" size="mini" style="margin-left:10px;width: 200px" type="date" readonly="readonly">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item label="非居住者である配偶者" prop="name">
                    <el-checkbox v-model="empFamilyForm.non_resident_is" style="margin-left:10px;"></el-checkbox>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item label="配偶者氏名（フリガナ）" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="empFamilyForm.name_frgn_family" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item label="配偶者個人番号" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="empFamilyForm.mynum_family" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item label="生計を一にする事実" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="empFamilyForm.work" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div>
                  <el-form-item label="配偶者住所" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="empFamilyForm.address" size="mini" style="margin-left:10px;width:810px" readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="給与所得（収入金額）" prop="name">
                    <el-input @change="inputIncomeSpouse()" v-model="ruleForm.income_year_spouse" size="mini" style="margin-left:10px;width: 200px" clearable></el-input>
                    &nbsp;円
                  </el-form-item>

                  <el-form-item label="給与所得以外の所得の合計額（所得金額）" prop="name">
                    <el-input @change="total_spouseCal()" v-model="ruleForm.income_outside_after_spouse" size="mini" style="margin-left:10px;width: 200px" clearable></el-input>
                    &nbsp;円
                  </el-form-item>

                  <el-form-item label="控除額の計算" prop="name">
                    <el-link style="margin-left:10px;" type="primary" class="el-icon-info" :underline="false" href="https://www.nta.go.jp/taxes/tetsuzuki/shinsei/annai/gensen/pdf/1648_73_r02.pdf" target="_blank">控除額の計算方法こちら</el-link>
                  </el-form-item>

                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item label="給与所得（所得金額）" prop="name">
                    <el-input v-model="ruleForm.income_after_spouse" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                    &nbsp;円
                  </el-form-item>

                  <el-form-item label="配偶者の本年中の合計所得金額の見積額" prop="name">
                    <el-input v-model="ruleForm.total_spouse" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                    &nbsp;円
                  </el-form-item>

                  <el-form-item label-width="0px" label="" prop="name" size="mini" style="font-weight:bold;color:red;text-align: left;">
                    <span style="font-size: 15px;">配偶者控除の額</span>
                    <el-input v-model="ruleForm.declaration_spouse" style="margin-left:110px;width: 185px" readonly="readonly"></el-input>
                    &nbsp;円
                    <el-button @click="spouse_d_amountCal()" class="fa fa-calculator" type="text">&nbsp;計算</el-button>
                  </el-form-item>

                  <el-form-item label-width="0px" label="" prop="name" size="mini" style="font-weight:bold;color:red;text-align: left;">
                    <span style="font-size: 15px;">配偶者特別控除の額</span>
                    <el-input v-model="ruleForm.declaration_special_spouse" style="margin-left:80px;width: 185px" readonly="readonly"></el-input>
                    &nbsp;円
                    <el-button @click="clearSpouse()" class="fa fa-refresh" type="text">&nbsp;配偶者情報クリア</el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item title="所得金額調整控除申告情報" name="3">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="所得金額調整控除要件" prop="requirement">
                    <el-select v-model="ruleForm.requirement" size="mini" placeholder="選択" style="margin-left:10px;width: 200px" clearable>
                      <el-option v-for="item in requirements" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                    <el-popover placement="top-start" title="所得金額調整控除申告情報記入方法" width="450" trigger="hover" content="年末調整において所得金額調整控除の適用を受けようとする場合は、「要件」欄の該当する項目にチェックを付け、その項目に応じて「☆扶養親族等」欄及び「★特別障害者」欄にその該当する者について記載してください。なお、「要件」欄の２以上の項目に該当する場合は、いずれか１つの要件について、チェックを付け記載をすることで差し支えありません。年末調整における所得金額調整控除の額については給与の支払者が計算しますので、この申告書に所得金額調整控除の額を記載する欄はありません。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item label="撫養親族氏名" prop="family_name">
                    <el-select v-model="adjustFamilyForm.name_family" style="margin-left:10px;width: 200px" size="mini" :no-data-text="$t('general.empty_data')" @change="familyNameSelected" :placeholder="$t('general.select')" clearable>
                      <el-option v-for="item in familyList" :key="item.id" :label="item.name_family" :value="item.name_family">
                      </el-option>
                    </el-select>
                    <el-popover placement="top-start" title="記入方法" width="450" trigger="hover" content="「要件」欄で「同一生計配偶者が特別障害者」、「扶養親族が特別障害者」、「扶養親族が年齢２３歳未満」の項目にチェックを付けた場合、その要件に該当する同一生計配偶者又は扶養親族の氏名">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item label="撫養親族生年月日" prop="name">
                    <el-date-picker v-model="adjustFamilyForm.birthday_family" size="mini" style="margin-left:10px;width: 200px" type="date" readonly="readonly">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item label="あなたとの続柄" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="adjustFamilyForm.mynum_family" size="mini" style="margin-left:10px;width: 200px" readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item label="氏名（フリガナ）" prop="name_frgn">
                    <el-input prefix-icon="el-icon-info" v-model="adjustFamilyForm.name_frgn_family" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.name_frgn')" readonly></el-input>
                  </el-form-item>

                  <el-form-item label="撫養親族個人番号" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="adjustFamilyForm.mynum_family" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item label="所得金額（見積額）" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="adjustFamilyForm.income" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div>
                  <el-form-item label="撫養親族住所" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="adjustFamilyForm.address" size="mini" style="margin-left:10px;width:810px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item label="特別障害者に該当する事実" prop="name">
                    <el-input v-model="ruleForm.description" size="mini" style="margin-left:10px;width:810px"></el-input>
                    <el-popover placement="top-start" title="記入方法" width="360" trigger="hover" content="「★特別障害者」欄の「特別障害者に該当する事実」欄には、障害の状態又は交付を受けている手帳などの種類と交付年月日、障害の程度（障害の等級）などの特別障害者に該当する事実を記載してください（特別障害者に該当する人が「扶養控除等申告書」に記載している特別障害者と同一である場合には、特別障害者に該当する事実の記載に代えて「扶養控除等申告書のとおり」と記載して差し支えありません。）。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addUser('ruleForm')" type="primary" size="medium">
          {{$t("general.confirm")}}</el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <!--edit-->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="86%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="210px" class="demo-ruleForm" size="medium" style="margin-left:20px" :label-position="labelPosition">
        <el-input type="hidden" v-model="ruleForm.id" />
        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item label="申告書年分" prop="year">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.year" size="mini" style="margin-left:10px;width: 200px" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('empPDF.name')" prop="name">
                <el-input prefix-icon="el-icon-info" v-model="empListForm.name" size="mini" style="margin-left:10px;width: 200px" :placeholder="$t('empPDF.name')" readonly></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <el-form-item>
                <span>
                  <br />
                </span>
              </el-form-item>

              <el-form-item :label="$t('empPDF.name_frgn')" prop="name_frgn">
                <el-input prefix-icon="el-icon-info" v-model="empListForm.name_frgn" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.name_frgn')" readonly></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <div>
              <el-form-item :label="$t('empPDF.address')" prop="address">
                <el-input :value="empListForm.address1 + empListForm.address2 + empListForm.address3" prefix-icon="el-icon-info" size="mini" style="margin-left:10px;width: 810px" :placeholder="$t('empPDF.address')" readonly></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-collapse>
          <el-collapse-item title="給与所得者の基礎控除申告情報" name="1">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="給与所得（収入金額）" prop="name">
                    <el-input @change="inputIncomeBasic()" v-model="ruleForm.income_year_basic" size="mini" style="margin-left:10px;width: 200px" placeholder="入力してください" clearable></el-input>
                    &nbsp;円
                    <el-popover placement="top-start" title="ヒント:" width="190" trigger="hover" content="給与明細から、年収金額をインポートします。">
                      <el-button @click="inportIncome()" slot="reference" class="el-icon-caret-bottom" type="text">&nbsp;データインポート</el-button>
                    </el-popover>
                  </el-form-item>
                  <el-form-item label="給与所得以外の所得の合計額（所得金額）" prop="name">
                    <el-input @change="total_basicCal()" v-model="ruleForm.income_outside_after_basic" size="mini" style="margin-left:10px;width: 200px" placeholder="入力してください" clearable></el-input>
                    &nbsp;円
                  </el-form-item>
                  <el-form-item label="控除額の計算判定" prop="name">
                    <el-select v-model="ruleForm.judgement_basic" size="mini" placeholder="計算式" style="margin-left:10px;width: 200px" clearable>
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item label="給与所得（所得金額）" prop="name">
                    <el-input v-model="ruleForm.income_after_basic" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                    &nbsp;円
                  </el-form-item>

                  <el-form-item label="あなたの本年中の合計所得金額の見積額" prop="name">
                    <el-input v-model="ruleForm.total_basic" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                    &nbsp;円
                  </el-form-item>

                  <el-form-item label-width="0px" label="" prop="name" size="mini" style="font-weight:bold;color:red;text-align: left;">
                    <span style="font-size: 15px;">基礎控除の額</span>
                    <el-input v-model="ruleForm.basic_d_amount" style="margin-left:125px;width: 185px" readonly="readonly"></el-input>
                    &nbsp;円
                    <el-popover placement="top-start" title="ヒント:" width="190" trigger="hover" content="基礎控除の額計算のため、クリックしてください。">
                      <el-button @click="basic_d_amountCal()" slot="reference" class="fa fa-calculator" type="text">&nbsp;計算</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item label="区分Ⅰ" prop="name">
                    <el-input v-model="ruleForm.division1" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item title="給与所得者の配偶者控除等申告情報" name="2">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="配偶者氏名" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="empFamilyForm.name_family" size="mini" style="margin-left:10px;width: 200px" readonly="readonly"></el-input>
                    <el-button @click="listFamilySpouse()" class="el-icon-caret-bottom" type="text">情報インポート</el-button>
                  </el-form-item>

                  <el-form-item label="配偶者生年月日" prop="name">
                    <el-date-picker v-model="empFamilyForm.birthday_family" size="mini" style="margin-left:10px;width: 200px" type="date" readonly="readonly">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item label="非居住者である配偶者" prop="name">
                    <el-checkbox v-model="empFamilyForm.non_resident_is" style="margin-left:10px;"></el-checkbox>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item label="配偶者氏名（フリガナ）" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="empFamilyForm.name_frgn_family" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item label="配偶者個人番号" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="empFamilyForm.mynum_family" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item label="生計を一にする事実" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="empFamilyForm.work" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                    &nbsp;円
                    <el-popover placement="top-start" title="ヒント:" width="190" trigger="hover" content="従業員情報ページに移動して撫養親族情報を編集してください。">
                      <el-button class="el-icon-info" type="text" slot="reference">&nbsp;撫養情報編集</el-button>
                    </el-popover>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div>
                  <el-form-item label="配偶者住所" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="empFamilyForm.address" size="mini" style="margin-left:10px;width:810px" readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="給与所得（収入金額）" prop="name">
                    <el-input @change="inputIncomeSpouse()" v-model="ruleForm.income_year_spouse" size="mini" style="margin-left:10px;width: 200px" clearable></el-input>
                    &nbsp;円
                  </el-form-item>

                  <el-form-item label="給与所得以外の所得の合計額（所得金額）" prop="name">
                    <el-input @change="total_spouseCal()" v-model="ruleForm.income_outside_after_spouse" size="mini" style="margin-left:10px;width: 200px" clearable></el-input>
                    &nbsp;円
                  </el-form-item>

                  <el-form-item label="控除額の計算" prop="name">
                    <el-link style="margin-left:10px;" type="primary" class="fa fa-link" :underline="false" href="https://www.nta.go.jp/taxes/tetsuzuki/shinsei/annai/gensen/pdf/1648_73_r02.pdf" target="_blank">&nbsp;控除額の計算方法こちら</el-link>
                  </el-form-item>

                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item label="給与所得（所得金額）" prop="name">
                    <el-input v-model="ruleForm.income_after_spouse" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                    &nbsp;円
                  </el-form-item>

                  <el-form-item label="配偶者の本年中の合計所得金額の見積額" prop="name">
                    <el-input v-model="ruleForm.total_spouse" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                    &nbsp;円
                  </el-form-item>

                  <el-form-item label-width="0px" label="" prop="name" size="mini" style="font-weight:bold;color:red;text-align: left;">
                    <span style="font-size: 15px;">配偶者控除の額</span>
                    <el-input v-model="ruleForm.declaration_spouse" style="margin-left:110px;width: 185px" readonly="readonly"></el-input>
                    &nbsp;円
                    <el-popover placement="top-start" title="ヒント:" width="190" trigger="hover" content="配偶者控除の額/配偶者特別控除の額計算のため、クリックしてください。">
                      <el-button @click="spouse_d_amountCal()" slot="reference" class="fa fa-calculator" type="text">&nbsp;計算</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item label-width="0px" label="" prop="name" size="mini" style="font-weight:bold;color:red;text-align: left;">
                    <span style="font-size: 15px;">配偶者特別控除の額</span>
                    <el-input v-model="ruleForm.declaration_special_spouse" style="margin-left:80px;width: 185px" readonly="readonly"></el-input>
                    &nbsp;円
                    <el-popover placement="top-start" title="ヒント:" width="190" trigger="hover" content="現在のページの配偶者情報はリセットされます">
                      <el-button @click="clearSpouse()" slot="reference" class="fa fa-refresh" type="text">&nbsp;配偶者情報クリア</el-button>
                    </el-popover>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item title="所得金額調整控除申告情報" name="3">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item label="所得金額調整控除要件" prop="requirement">
                    <el-select v-model="ruleForm.requirement" size="mini" placeholder="選択" style="margin-left:10px;width: 200px" clearable>
                      <el-option v-for="item in requirements" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                    <el-popover placement="top-start" title="所得金額調整控除申告情報記入方法" width="450" trigger="hover" content="年末調整において所得金額調整控除の適用を受けようとする場合は、「要件」欄の該当する項目にチェックを付け、その項目に応じて「☆扶養親族等」欄及び「★特別障害者」欄にその該当する者について記載してください。なお、「要件」欄の２以上の項目に該当する場合は、いずれか１つの要件について、チェックを付け記載をすることで差し支えありません。年末調整における所得金額調整控除の額については給与の支払者が計算しますので、この申告書に所得金額調整控除の額を記載する欄はありません。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item label="撫養親族氏名" prop="family_name">
                    <el-select v-model="adjustFamilyForm.name_family" style="margin-left:10px;width: 200px" size="mini" :no-data-text="$t('general.empty_data')" @change="familyNameSelected" :placeholder="$t('general.select')" clearable>
                      <el-option v-for="item in familyList" :key="item.id" :label="item.name_family" :value="item.id">
                      </el-option>
                    </el-select>
                    <el-popover placement="top-start" title="記入方法" width="450" trigger="hover" content="「要件」欄で「同一生計配偶者が特別障害者」、「扶養親族が特別障害者」、「扶養親族が年齢２３歳未満」の項目にチェックを付けた場合、その要件に該当する同一生計配偶者又は扶養親族の氏名">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>

                  <el-form-item label="撫養親族生年月日" prop="name">
                    <el-date-picker v-model="adjustFamilyForm.birthday_family" size="mini" style="margin-left:10px;width: 200px" type="date" readonly="readonly">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item label="あなたとの続柄" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="adjustFamilyForm.mynum_family" size="mini" style="margin-left:10px;width: 200px" readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item label="氏名（フリガナ）" prop="name_frgn">
                    <el-input prefix-icon="el-icon-info" v-model="adjustFamilyForm.name_frgn_family" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('empPDF.name_frgn')" readonly></el-input>
                  </el-form-item>

                  <el-form-item label="撫養親族個人番号" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="adjustFamilyForm.mynum_family" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item label="所得金額（見積額）" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="adjustFamilyForm.income" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div>
                  <el-form-item label="撫養親族住所" prop="name">
                    <el-input prefix-icon="el-icon-info" v-model="adjustFamilyForm.address" size="mini" style="margin-left:10px;width:810px" readonly="readonly"></el-input>
                  </el-form-item>
                  
                  <el-form-item label="特別障害者に該当する事実" prop="name">
                    <el-input v-model="ruleForm.description" size="mini" style="margin-left:10px;width:810px"></el-input>
                    <el-popover placement="top-start" title="記入方法" width="360" trigger="hover" content="「★特別障害者」欄の「特別障害者に該当する事実」欄には、障害の状態又は交付を受けている手帳などの種類と交付年月日、障害の程度（障害の等級）などの特別障害者に該当する事実を記載してください（特別障害者に該当する人が「扶養控除等申告書」に記載している特別障害者と同一である場合には、特別障害者に該当する事実の記載に代えて「扶養控除等申告書のとおり」と記載して差し支えありません。）。">
                      <el-button class="el-icon-info" type="text" slot="reference">ヒント</el-button>
                    </el-popover>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateUser('ruleForm')" type="primary" size="medium">
          {{$t("general.confirm")}}</el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      options: [{
        value: "A",
        label: '900万円以下 区分A 48万円',
        disabled: true
      }, {
        value: "B",
        label: '900万円超 950万円以下 区分B 48万円',
        disabled: true
      }, {
        value: "C",
        label: '950万円超 1,000万円以下 区分C 48万円',
        disabled: true
      }, {
        value: "D",
        label: '1,000万円超 2,400万円以下 48万円',
        disabled: true
      }, {
        value: "E",
        label: '2,400万円超 2,450万円以下 32万円',
        disabled: true
      }, {
        value: "F",
        label: '2,450万円超 2,500万円以下 16万円',
        disabled: true
      }],
      options2: [{
        value: "①",
        label: '48万円以下かつ年齢70歳以上（昭26.1.1以前生）《老人控除対象配偶者に該当》',
        disabled: true
      }, {
        value: "②",
        label: '48万円以下かつ年齢70歳未満',
        disabled: true
      }, {
        value: "③",
        label: '48万円超95万円以下',
        disabled: true
      }, {
        value: "④",
        label: '95万円超133万円以下',
        disabled: true
      }],
      years: [{
        value: "令和2年分",
        label: '令和2年'
      },
      {
        value: "令和3年分",
        label: '令和3年'
      }
      ],
      requirements: [{
        value: "あなた自身が特別障害者",
        label: 'あなた自身が特別障害者',
        disabled: true
      }, {
        value: "同一生計配偶者が特別障害者",
        label: '同一生計配偶者が特別障害者',
        disabled: true
      }, {
        value: "扶養親族が特別障害者",
        label: '扶養親族が特別障害者',
        disabled: true
      }, {
        value: "扶養親族が年齢23歳未満（平10.1.2以後生）",
        label: '扶養親族が年齢23歳未満（平10.1.2以後生）',
        disabled: true
      }],
      labelPosition: "left",
      value: "",
      empListForm: {
        id: "",
        employee_id: "",
        name: "",
        name_frgn: "",
        address1: "",
        address2: "",
        address3: ""
      },
      //給与所得者の配偶者控除等申告書データ
      empFamilyForm: {
        id: "",
        eid: "",
        name_family: "",
        name_frgn_family: "",
        birthday_family: "",
        mynum_family: "",
        non_resident_is: "",
        money_raise: "",
        address: "",
      },
      //所得金額調整控除申告書データ
      adjustFamilyForm: {
        id: "",
        eid: "",
        name_family: "",
        name_frgn_family: "",
        birthday_family: "",
        mynum_family: "",
        relation: "",
        income: "",
        address: "",
      },
      familyList: [],
      empList: [],
      ruleForm: {
        id: "",
        year: "",
        income_year_basic: 0,
        income_after_basic: 0,
        income_outside_after_basic: 0,
        total_basic: 0,
        judgement_basic: "",
        division1: "",
        basic_d_amount: 0,
        income_year_spouse: 0,
        income_after_spouse: 0,
        income_outside_after_spouse: 0,
        total_spouse: 0,
        judgement_spouse: "",
        division2: "",
        declaration_spouse: 0,
        declaration_special_spouse: 0,
        requirement: "",
        requirement_is: "無",
        description: "",
        family_id: "",
      },
      rules: {
        employee_id: [{
          required: true,
          message: this.$t("companyInfo.fill"),
          trigger: "blur",
        },],
        year: [{
          required: true,
          message: this.$t("companyInfo.fill"),
          trigger: "blur",
        },],
      },
      tableData: [],
      basicDecData: [],
      dialogVisible: false,
      dialogUpdate: false,
      dialogBasicDeclaration: false,
      pageSize: 6,
      currentPage: 1,
      total: 0,
      disablePage: false,
      loading: false,
      sortName: "",
      sortOrder: "",
      eid: "",
      employee_id: "",
      name: ""
    };
  },
  methods: {
    //选择family
    familyNameSelected() {
      if (this.adjustFamilyForm.name_family === 0 || this.adjustFamilyForm.name_family === "") {
        this.adjustFamilyForm.name_family = "";
        this.adjustFamilyForm.name_frgn_family = "";
        this.adjustFamilyForm.birthday_family = "";
        this.adjustFamilyForm.mynum_family = "";
        this.adjustFamilyForm.relation = "";
        this.adjustFamilyForm.income = "";
        this.adjustFamilyForm.address = "";
        this.ruleForm.family_id = 0;
      }
      for (var i = 0; i < this.familyList.length; i++) {
        if (this.familyList[i].id === this.adjustFamilyForm.name_family) {
          this.adjustFamilyForm.name_frgn_family = this.familyList[i].name_frgn_family;
          this.adjustFamilyForm.birthday_family = this.familyList[i].birthday_family;
          this.adjustFamilyForm.mynum_family = this.familyList[i].mynum_family;
          this.adjustFamilyForm.relation = this.familyList[i].relation;
          this.adjustFamilyForm.income = this.familyList[i].income;
          this.adjustFamilyForm.address = this.familyList[i].address;
          this.ruleForm.family_id = this.familyList[i].id;
        }
      }
    },
    //查询family信息
    pageFamily() {
      let postData = this.qs.stringify({
        eid: this.eid,
      });
      this.axios({
        method: "post",
        url: "/pageFamily",
        data: postData,
      })
        .then((response) => {
          for (var i = 0; i < response.data.length; i++) {
            response.data[i].income = Number(response.data[i].income).toLocaleString();
          }
          this.familyList = response.data;
        })
        .catch((error) => {
        });
    },
    jump(path) {
      this.$router.push(path);
    },
    //基礎控除/配偶者控除/所得金額調整控除申告页面新规按钮
    handleAdd() {
      this.dialogVisible = true;
      this.employeeIdSelected();
    },
    //JS比较两个对象内容是否相同
    isObjectValueEqual(a, b) {
      var aProps = Object.keys(a);
      var bProps = Object.keys(b);
      if (aProps.length != bProps.length) {
        return false;
      }
      for (var i = 0; i < aProps.length; i++) {
        var key = aProps[i];
        var valueA = a[key];
        var valueB = b[key];
        if (valueA !== valueB) {
          return false;
        }
      }
      return true;
    },
    //基礎控除/配偶者控除/所得金額調整控除申告を押下
    handleBasicDeclaration(index, row) {
      this.dialogBasicDeclaration = true;
      this.eid = row.id;
      this.employee_id = row.employee_id;
      this.name = row.name;
      this.handleCurrentChange();
      this.pageFamily();
    },
    //点击table表格的排序箭头
    changeTableSort(column) {
      this.sortName = column.prop;
      this.sortOrder = column.order;
      let postData = this.qs.stringify({
        sortName: this.sortName,
        sortOrder: this.sortOrder,
        page: this.currentPage
      });
      this.axios({
        method: "post",
        url: "/changeTableSort",
        data: postData,
      })
        .then((response) => {
          this.tableData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
      localStorage.setItem("sortNameSalaryMain", JSON.stringify(this.sortName));
      localStorage.setItem("sortOrderSalaryMain", JSON.stringify(this.sortOrder));
    },
    //点击分页页码
    handleSortChange(column) {
      this.sortName = column.prop;
      this.sortOrder = column.order;
      let postData = this.qs.stringify({
        sortName: JSON.parse(localStorage.getItem("sortNameSalaryMain")),
        sortOrder: JSON.parse(localStorage.getItem("sortOrderSalaryMain")),
        page: this.currentPage
      });
      this.axios({
        method: "post",
        url: "/changeTableSort",
        data: postData,
      })
        .then((response) => {
          this.tableData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    printPDF(index, row) {
      this.loading = true;
      let postData = this.qs.stringify({
        id: row.id,
        year: row.year,
        employee_id: this.employee_id,
        eid: this.eid
      });
      this.axios({
        method: "post",
        url: "/printBasicDeclaration",
        data: postData,
      })
        .then((response) => {
          if (response.data.status === "success") {
            this.$message({
              type: "success",
              message: this.$t("general.print_completed"),
            });
            var code = response.data.msg;
            setTimeout(() => { this.preview(index, row, code); }, 700);
            this.loading = false;
          } else {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed"),
            });
            this.loading = false;
          }
        })
        .catch((error) => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed"),
          });
          this.loading = false;
          console.log(error);
        });
    },
    preview(index, row, code) {
      var uid = window.localStorage.getItem('LoginUserId');
      var name = this.name;
      window.open("/pdf/給与所得者の基礎控除申告書兼給与所得者の配偶者控除等申告書兼所得金額調整控除申告書-" + row.year + name + "no." + uid + code + ".pdf");
    },
    //从给与明细信息中导入该年总的收入金额
    inportIncome() {
      var tempYear = "";
      if (this.ruleForm.year === "令和2年分") {
        tempYear = "2020";
      } else if (this.ruleForm.year === "令和3年分") {
        tempYear = "2021";
      } else {
        this.$message({
          message: 'まず申告年分を選択ください。',
          type: 'error'
        });
        return 0;
      }
      let postData = this.qs.stringify({
        employee_id: this.employee_id,
        year: tempYear,
      });
      this.axios({
        method: "post",
        url: "/listAllYearSalary",
        data: postData,
      })
        .then((response) => {
          this.ruleForm.income_year_basic = 0;
          for (var i = 0; i < response.data.length; i++) {
            this.ruleForm.income_year_basic += Number(response.data[i].salary_total);
          }
          this.ruleForm.income_after_basic = this.afterIncomeCal(Number(this.ruleForm.income_year_basic)).toLocaleString();
          this.total_basicCal();
          this.ruleForm.income_year_basic = Number(this.ruleForm.income_year_basic).toLocaleString();
          this.$message({
            message: 'インポートしました。',
            type: 'success'
          });
        })
        .catch((error) => {
          this.$message({
            message: '給与明細データを見つかりません。',
            type: 'error'
          });
          console.log(error);
        });
    },
    //配偶者控除输入收入金额，触发的方法。
    inputIncomeSpouse() {
      this.ruleForm.income_after_spouse = this.afterIncomeCal(this.ruleForm.income_year_spouse).toLocaleString();
      this.total_spouseCal();
      this.handleToMoney();
    },
    //基礎控除输入收入金额，触发的方法。
    inputIncomeBasic() {
      this.ruleForm.income_after_basic = this.afterIncomeCal(Number(this.ruleForm.income_year_basic)).toLocaleString();
      this.total_basicCal();
      this.handleToMoney();
    },
    //根据收入金额，计算所得金额
    afterIncomeCal(val) {
      if (1 <= val && val <= 550999) {
        return 0;
      } else if (551000 <= val && val <= 1618999) {
        return (val - 550000);
      } else if (1619000 <= val && val <= 1619999) {
        return 1069000;
      } else if (1620000 <= val && val <= 1621999) {
        return 1070000;
      } else if (1622000 <= val && val <= 1623999) {
        return 1072000;
      } else if (1624000 <= val && val <= 1627999) {
        return 1074000;
      } else if (1628000 <= val && val <= 1799999) {
        return (Math.floor(val / 4000) * 1000 * 2.4 + 100000);
      } else if (1800000 <= val && val <= 3599999) {
        return (Math.floor(val / 4000) * 1000 * 2.8 - 80000);
      } else if (3600000 <= val && val <= 6599999) {
        return (Math.floor(val / 4000) * 1000 * 3.2 - 440000);
      } else if (6600000 <= val && val <= 8499999) {
        return (val * 0.9 - 1100000);
      } else if (8500000 <= val) {
        return (val - 1950000 - (val - 8500000) * 0.1);
      } else if (10000000 <= val) {
        return (val - 1950000 - 150000);
      }
    },
    //不参与计算的数字始终保持Money格式。
    handleToMoney() {
      if (String(this.ruleForm.income_year_basic).indexOf(",") != -1 || String(this.ruleForm.income_year_spouse).indexOf(",") != -1) {
        this.ruleForm.income_year_basic = Number(this.ruleForm.income_year_basic.split(",").join(""));
        this.ruleForm.income_year_spouse = Number(this.ruleForm.income_year_spouse.split(",").join(""));
      }
      this.ruleForm.income_year_basic = Number(this.ruleForm.income_year_basic).toLocaleString();
      this.ruleForm.income_year_spouse = Number(this.ruleForm.income_year_spouse).toLocaleString();
    },
    //参与计算的项目转换成Money格式
    handleToMoneyCal() {
      //基礎控除
      this.ruleForm.income_after_basic = Number(this.ruleForm.income_after_basic).toLocaleString();
      this.ruleForm.income_outside_after_basic = Number(this.ruleForm.income_outside_after_basic).toLocaleString();
      this.ruleForm.total_basic = Number(this.ruleForm.total_basic).toLocaleString();
      this.ruleForm.basic_d_amount = Number(this.ruleForm.basic_d_amount).toLocaleString();
      //配偶者控除
      this.ruleForm.income_after_spouse = Number(this.ruleForm.income_after_spouse).toLocaleString();
      this.ruleForm.income_outside_after_spouse = Number(this.ruleForm.income_outside_after_spouse).toLocaleString();
      this.ruleForm.total_spouse = Number(this.ruleForm.total_spouse).toLocaleString();
      this.ruleForm.declaration_spouse = Number(this.ruleForm.declaration_spouse).toLocaleString();
      this.ruleForm.declaration_special_spouse = Number(this.ruleForm.declaration_special_spouse).toLocaleString();
    },
    //转换成数字字符串
    handleToNumString() {
      //基礎控除
      this.ruleForm.income_after_basic = String(this.ruleForm.income_after_basic);
      this.ruleForm.income_outside_after_basic = String(this.ruleForm.income_outside_after_basic);
      this.ruleForm.total_basic = String(this.ruleForm.total_basic);
      this.ruleForm.basic_d_amount = String(this.ruleForm.basic_d_amount);

      //配偶者控除
      this.ruleForm.income_after_spouse = String(this.ruleForm.income_after_spouse);
      this.ruleForm.income_outside_after_spouse = String(this.ruleForm.income_outside_after_spouse);
      this.ruleForm.total_spouse = String(this.ruleForm.total_spouse);
      this.ruleForm.declaration_spouse = String(this.ruleForm.declaration_spouse);
      this.ruleForm.declaration_special_spouse = String(this.ruleForm.declaration_special_spouse);
    },
    //将Money格式转成数字，为了参与计算
    handleToNumber() {
      this.handleToNumString();
      //基礎控除
      this.ruleForm.income_after_basic = Number(this.ruleForm.income_after_basic.split(",").join(""));
      this.ruleForm.income_outside_after_basic = Number(this.ruleForm.income_outside_after_basic.split(",").join(""));
      this.ruleForm.total_basic = Number(this.ruleForm.total_basic.split(",").join(""));
      this.ruleForm.basic_d_amount = Number(this.ruleForm.basic_d_amount.split(",").join(""));
      //配偶者控除
      this.ruleForm.income_after_spouse = Number(this.ruleForm.income_after_spouse.split(",").join(""));
      this.ruleForm.income_outside_after_spouse = Number(this.ruleForm.income_outside_after_spouse.split(",").join(""));
      this.ruleForm.total_spouse = Number(this.ruleForm.total_spouse.split(",").join(""));
      this.ruleForm.declaration_spouse = Number(this.ruleForm.declaration_spouse.split(",").join(""));
      this.ruleForm.declaration_special_spouse = Number(this.ruleForm.declaration_special_spouse.split(",").join(""));
    },
    //あなたの本年中の合計所得金額の見積額 基礎控除
    total_basicCal() {
      this.handleToNumber();
      this.ruleForm.total_basic = Number(this.ruleForm.income_after_basic) + Number(this.ruleForm.income_outside_after_basic);
      this.handleToMoneyCal();
    },
    //配偶者の本年中の合計所得金額の見積額
    total_spouseCal() {
      this.handleToNumber();
      this.ruleForm.total_spouse = Number(this.ruleForm.income_after_spouse) + Number(this.ruleForm.income_outside_after_spouse);
      this.handleToMoneyCal();
    },
    //基礎控除の額 計算
    basic_d_amountCal() {
      var b = Number(this.ruleForm.total_basic.split(",").join(""));
      //令和2年的计算方法，如果方法变更，增加年份条件，再追加新的计算方法
      //"900以下"是包括900的，"900超"不包括900
      if (b <= 9000000) {
        this.ruleForm.basic_d_amount = "480,000";
        this.ruleForm.division1 = "A";
      } else if (b > 9000000 && b <= 9500000) {
        this.ruleForm.basic_d_amount = "480,000";
        this.ruleForm.division1 = "B";
      } else if (b > 9500000 && b <= 10000000) {
        this.ruleForm.basic_d_amount = "480,000";
        this.ruleForm.division1 = "C";
      } else if (b > 10000000 && b <= 24000000) {
        this.ruleForm.basic_d_amount = "480,000";
        this.ruleForm.division1 = "";
      } else if (b > 24000000 && b <= 24500000) {
        this.ruleForm.basic_d_amount = "320,000";
        this.ruleForm.division1 = "";
      } else if (b > 24500000 && b <= 25000000) {
        this.ruleForm.basic_d_amount = "160,000";
        this.ruleForm.division1 = "";
      }
    },
    //配偶者控除の額、配偶者特別控除の額計算
    spouse_d_amountCal() {
      this.ruleForm.declaration_spouse = 0;
      this.ruleForm.declaration_special_spouse = 0;
      var sd = Number(this.ruleForm.total_spouse.split(",").join(""));
      var birthday = new Date(this.empFamilyForm.birthday_family.replace(/-/g, "\/"));
      var d = new Date();
      var age = d.getFullYear() - birthday.getFullYear() - ((d.getMonth() < birthday.getMonth() || d.getMonth() == birthday.getMonth() && d.getDate() < birthday.getDate()) ? 1 : 0);
      //令和2年的计算方法。如何下一年度计算方法变更，增加年份的条件，再追加新的计算方法。
      //"900以下"是包括900的，"900超"不包括900
      if (sd <= 480000 && age >= 70) {
        this.ruleForm.division2 = "①";
      } else if (sd <= 480000 && age < 70) {
        this.ruleForm.division2 = "②";
      } else if (sd > 480000 && sd <= 950000) {
        this.ruleForm.division2 = "③";
      } else if (sd > 950000 && sd <= 1330000) {
        this.ruleForm.division2 = "④";
      } else {
        this.$message({
          message: '配偶者控除の条件を満たしていない',
          type: 'warning'
        });
      }
      switch (this.ruleForm.division2) {
        case '①':
          if (this.ruleForm.division1 === "A") {
            this.ruleForm.declaration_spouse = "480,000";
          } else if (this.ruleForm.division1 === "B") {
            this.ruleForm.declaration_spouse = "320,000";
          } else if (this.ruleForm.division1 === "C") {
            this.ruleForm.declaration_spouse = "160,000";
          } else {
            this.$message({
              message: '配偶者控除の条件を満たしていない',
              type: 'warning'
            });
          }
          break;
        case '②':
          if (this.ruleForm.division1 === "A") {
            this.ruleForm.declaration_spouse = "380,000";
          } else if (this.ruleForm.division1 === "B") {
            this.ruleForm.declaration_spouse = "260,000";
          } else if (this.ruleForm.division1 === "C") {
            this.ruleForm.declaration_spouse = "130,000";
          } else {
            this.$message({
              message: '配偶者控除の条件を満たしていない',
              type: 'warning'
            });
          }
          break;
        case '③':
          if (this.ruleForm.division1 === "A") {
            this.ruleForm.declaration_special_spouse = "380,000";
          } else if (this.ruleForm.division1 === "B") {
            this.ruleForm.declaration_special_spouse = "260,000";
          } else if (this.ruleForm.division1 === "C") {
            this.ruleForm.declaration_special_spouse = "130,000";
          } else {
            this.$message({
              message: '配偶者控除の条件を満たしていない',
              type: 'warning'
            });
          }
          break;
        case '④':
          switch (this.ruleForm.division1) {
            case 'A':
              if (sd > 950000 && sd <= 1000000) {
                this.ruleForm.declaration_special_spouse = "360,000";
              } else if (sd > 1000000 && sd <= 1050000) {
                this.ruleForm.declaration_special_spouse = "310,000";
              } else if (sd > 1050000 && sd <= 1100000) {
                this.ruleForm.declaration_special_spouse = "260,000";
              } else if (sd > 1100000 && sd <= 1150000) {
                this.ruleForm.declaration_special_spouse = "210,000";
              } else if (sd > 1150000 && sd <= 1200000) {
                this.ruleForm.declaration_special_spouse = "160,000";
              } else if (sd > 1200000 && sd <= 1250000) {
                this.ruleForm.declaration_special_spouse = "110,000";
              } else if (sd > 1250000 && sd <= 1300000) {
                this.ruleForm.declaration_special_spouse = "60,000";
              } else if (sd > 1300000 && sd <= 1330000) {
                this.ruleForm.declaration_special_spouse = "30,000";
              }
              break;
            case 'B':
              if (sd > 950000 && sd <= 1000000) {
                this.ruleForm.declaration_special_spouse = "240,000";
              } else if (sd > 1000000 && sd <= 1050000) {
                this.ruleForm.declaration_special_spouse = "210,000";
              } else if (sd > 1050000 && sd <= 1100000) {
                this.ruleForm.declaration_special_spouse = "180,000";
              } else if (sd > 1100000 && sd <= 1150000) {
                this.ruleForm.declaration_special_spouse = "140,000";
              } else if (sd > 1150000 && sd <= 1200000) {
                this.ruleForm.declaration_special_spouse = "110,000";
              } else if (sd > 1200000 && sd <= 1250000) {
                this.ruleForm.declaration_special_spouse = "80,000";
              } else if (sd > 1250000 && sd <= 1300000) {
                this.ruleForm.declaration_special_spouse = "40,000";
              } else if (sd > 1300000 && sd <= 1330000) {
                this.ruleForm.declaration_special_spouse = "20,000";
              }
              break;
            case 'C':
              if (sd > 950000 && sd <= 1000000) {
                this.ruleForm.declaration_special_spouse = "120,000";
              } else if (sd > 1000000 && sd <= 1050000) {
                this.ruleForm.declaration_special_spouse = "110,000";
              } else if (sd > 1050000 && sd <= 1100000) {
                this.ruleForm.declaration_special_spouse = "90,000";
              } else if (sd > 1100000 && sd <= 1150000) {
                this.ruleForm.declaration_special_spouse = "70,000";
              } else if (sd > 1150000 && sd <= 1200000) {
                this.ruleForm.declaration_special_spouse = "60,000";
              } else if (sd > 1200000 && sd <= 1250000) {
                this.ruleForm.declaration_special_spouse = "40,000";
              } else if (sd > 1250000 && sd <= 1300000) {
                this.ruleForm.declaration_special_spouse = "20,000";
              } else if (sd > 1300000 && sd <= 1330000) {
                this.ruleForm.declaration_special_spouse = "10,000";
              }
              break;
            default:
              this.$message({
                message: '配偶者控除の条件を満たしていない',
                type: 'warning'
              });
          }
          break;
      }

    },
    //导入配偶信息
    listFamilySpouse() {
      let postData = this.qs.stringify({
        eid: this.empFamilyForm.eid,
      });
      this.axios({
        method: "post",
        url: "/listFamilySpouse",
        data: postData,
      })
        .then((response) => {
          //通过eid查询的员工的配偶的信息存入empFamilyForm中。
          if (response.data === "" || response.data === null || response.data === undefined) {
            this.$message({
              message: '配偶者情報が見つかりません',
              type: 'error'
            });
          } else {
            this.empFamilyForm = response.data;
          }

        })
        .catch((error) => {
          console.log(error);
        });
    },
    //选择员工番号，返回员工信息
    employeeIdSelected() {
      let postData = this.qs.stringify({
        employee_id: this.employee_id,
      });
      this.axios({
        method: "post",
        url: "/ListEmpList",
        data: postData,
      })
        .then((response) => {
          //通过employee_id查询的员工信息存入empListForm中。
          //eid = empListForm.id
          this.empListForm = response.data[0];
          this.ruleForm.eid = this.empListForm.id;
          this.empFamilyForm.eid = this.empListForm.id;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleEdit(index, row) {
      this.dialogUpdate = true;
      //返回对象属性比ruleForm少时，需要assign方法中间加ruleForm参数。不然vue监听不到缺少的ruleForm属性。
      this.ruleForm = Object.assign({}, row);
      this.adjustFamilyForm.name_family = this.ruleForm.family_id;
      this.familyNameSelected();
      this.handleToNumber();
      let postData = this.qs.stringify({
        employee_id: this.employee_id,
      });
      this.axios({
        method: "post",
        url: "/ListEmpList",
        data: postData,
      })
        .then((response) => {
          //通过employee_id查询的员工信息存入empListForm中。
          //eid = empListForm.id
          this.empListForm = response.data[0];
          this.ruleForm.eid = this.empListForm.id;
          this.empFamilyForm.eid = this.empListForm.id;
          if (this.ruleForm.total_spouse > 0) {
            this.listFamilySpouse();
          }
          this.handleToMoney();
          this.handleToMoneyCal();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleClose(done) {
      this.$confirm(this.$t("general.close_comfirm"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then((_) => {
          this.emptyUserData();
          done();
        })
        .catch((_) => { });
    },
    handleDelete(index, row) {
      this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: "OK",
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then(() => {
          let postData = this.qs.stringify({
            id: row.id,
          });
          this.axios({
            method: "post",
            url: "/deleteBasicDeclaration",
            data: postData,
          })
            .then((response) => {
              var result = response.data;
              if (result != 0) {
                this.handleCurrentChange();
                this.$message({
                  type: "success",
                  message: this.$t("general.delete_completed"),
                });
              } else {
                this.$message({
                  type: "warning",
                  message: "エラーが発生しました",
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("general.canceled"),
          });
        });
    },
    handleCurrentChange() {
      let postData = this.qs.stringify({
        eid: this.eid
      });
      this.axios({
        method: "post",
        url: "/pageBasicDeclaration",
        data: postData,
      })
        .then((response) => {
          this.basicDecData = response.data;
          //转money形式
          for (var i = 0; i < response.data.length; i++) {
            this.basicDecData[i].basic_d_amount = Number(response.data[i].basic_d_amount).toLocaleString();
            this.basicDecData[i].declaration_spouse = Number(response.data[i].declaration_spouse).toLocaleString();
            this.basicDecData[i].declaration_special_spouse = Number(response.data[i].declaration_special_spouse).toLocaleString();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    s1_cancel(ruleForm) {
      this.dialogUpdate = false;
      this.dialogVisible = false;
      this.emptyUserData();
      this.$refs[ruleForm].resetFields();
    },
    cancel() {
      this.dialogUpdate = false;
      this.dialogVisible = false;
      this.emptyUserData();
    },
    clearSpouse() {
      this.empFamilyForm = {
        id: "",
        eid: "",
        name_family: "",
        name_frgn_family: "",
        birthday_family: "",
        mynum_family: "",
        non_resident_is: "",
        work: "",
        address: "",
      }
      this.ruleForm.income_year_spouse = 0;
      this.ruleForm.income_after_spouse = 0;
      this.ruleForm.income_outside_after_spouse = 0;
      this.ruleForm.total_spouse = 0;
      this.ruleForm.judgement_spouse = "";
      this.ruleForm.division2 = "";
      this.ruleForm.declaration_spouse = 0;
      this.ruleForm.declaration_special_spouse = 0;
    },
    //清空Form中当前数据
    emptyUserData() {
      this.adjustFamilyForm = {
        id: "",
        eid: "",
        name_family: "",
        name_frgn_family: "",
        birthday_family: "",
        mynum_family: "",
        relation: "",
        income: "",
        address: ""
      }
      this.empFamilyForm = {
        id: "",
        eid: "",
        name_family: "",
        name_frgn_family: "",
        birthday_family: "",
        mynum_family: "",
        non_resident_is: "",
        money_raise: "",
        address: ""
      }
      this.empListForm = {
        id: "",
        employee_id: "",
        name: "",
        name_frgn: "",
        address1: "",
        address2: "",
        address3: ""
      }
      this.ruleForm = {
        id: "",
        eid: "",
        year: "",
        income_year_basic: 0,
        income_after_basic: 0,
        income_outside_after_basic: 0,
        total_basic: 0,
        judgement_basic: "",
        division1: "",
        basic_d_amount: 0,
        income_year_spouse: 0,
        income_after_spouse: 0,
        income_outside_after_spouse: 0,
        total_spouse: 0,
        judgement_spouse: "",
        division2: "",
        declaration_spouse: 0,
        declaration_special_spouse: 0,
        requirement: "",
        requirement_is: "無",
        description: "",
      };
    },
    addUser(ruleForm) {
      this.handleToNumber();
      this.ruleForm.income_year_basic = Number(this.ruleForm.income_year_basic.split(",").join(""));
      this.ruleForm.income_year_spouse = Number(this.ruleForm.income_year_spouse.split(",").join(""));
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            eid: this.eid,
            year: this.ruleForm.year,
            income_year_basic: this.ruleForm.income_year_basic,
            income_after_basic: this.ruleForm.income_after_basic,
            income_outside_after_basic: this.ruleForm.income_outside_after_basic,
            total_basic: this.ruleForm.total_basic,
            judgement_basic: this.ruleForm.judgement_basic,
            division1: this.ruleForm.division1,
            basic_d_amount: this.ruleForm.basic_d_amount,
            income_year_spouse: this.ruleForm.income_year_spouse,
            income_after_spouse: this.ruleForm.income_after_spouse,
            income_outside_after_spouse: this.ruleForm.income_outside_after_spouse,
            total_spouse: this.ruleForm.total_spouse,
            judgement_spouse: this.ruleForm.judgement_spouse,
            division2: this.ruleForm.division2,
            declaration_spouse: this.ruleForm.declaration_spouse,
            declaration_special_spouse: this.ruleForm.declaration_special_spouse,
            requirement: this.ruleForm.requirement,
            // requirement_is: this.ruleForm.requirement_is,
            description: this.ruleForm.description,
            family_id: this.ruleForm.family_id,
          });
          this.axios({
            method: "post",
            url: "/insertBasicDeclaration",
            data: postData,
          })
            .then((response) => {
              var result = response.data;
              if (result > 0) {
                this.handleCurrentChange();
                this.$message({
                  type: "success",
                  message: this.$t("general.add_completed"),
                });
                this.dialogVisible = false;
              } else {
                this.$message({
                  type: "warning",
                  message: this.$t("general.add_failed"),
                });
              }
            })
            .catch((error) => {
              this.$message({
                type: "warning",
                message: this.$t("general.add_failed"),
              });
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message.error('必須項目が入力されていません');
          return false;
        }
      });
    },
    updateUser(ruleForm) {
      this.handleToNumber();
      this.ruleForm.income_year_basic = Number(String(this.ruleForm.income_year_basic).split(",").join(""));
      this.ruleForm.income_year_spouse = Number(String(this.ruleForm.income_year_spouse).split(",").join(""));
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            id: this.ruleForm.id,
            eid: this.eid,
            year: this.ruleForm.year,
            income_year_basic: this.ruleForm.income_year_basic,
            income_after_basic: this.ruleForm.income_after_basic,
            income_outside_after_basic: this.ruleForm.income_outside_after_basic,
            total_basic: this.ruleForm.total_basic,
            judgement_basic: this.ruleForm.judgement_basic,
            division1: this.ruleForm.division1,
            basic_d_amount: this.ruleForm.basic_d_amount,
            income_year_spouse: this.ruleForm.income_year_spouse,
            income_after_spouse: this.ruleForm.income_after_spouse,
            income_outside_after_spouse: this.ruleForm.income_outside_after_spouse,
            total_spouse: this.ruleForm.total_spouse,
            judgement_spouse: this.ruleForm.judgement_spouse,
            division2: this.ruleForm.division2,
            declaration_spouse: this.ruleForm.declaration_spouse,
            declaration_special_spouse: this.ruleForm.declaration_special_spouse,
            requirement: this.ruleForm.requirement,
            description: this.ruleForm.description,
            family_id: this.ruleForm.family_id,
          });
          this.axios({
            method: "post",
            url: "/updateBasicDeclaration",
            data: postData,
          })
            .then((response) => {
              var result = response.data;
              if (result > 0) {
                this.handleCurrentChange();
                this.s1_cancel(ruleForm);
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_completed"),
                });
                this.dialogUpdate = false;
              }
            })
            .catch((error) => {
              this.$message({
                type: "warning",
                message: this.$t("general.edit_failed"),
              });
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message.error('必須項目が入力されていません');
          return false;
        }
      });
    },
    refreshData() {
      location.reload();
    },
  },
  created() {
    this.axios
      .post("/pageEmpList")
      .then((response) => {

        this.tableData = response.data;
      })
      .catch((error) => {
      });
    this.axios
      .post("/rowsEmpList")
      .then((response) => {
        this.total = response.data;
      })
      .catch((error) => {
      });
  },
};
</script>

<style>
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
  width: 90px;
}

.btn-custom-confirm {
  width: 90px;
}
</style>
<style scoped>
.search_name {
  width: 200px;
}

.pages {
  margin: 0px;
  padding: 0px;
  text-align: right;
}

.style1 {
  margin-right: 130px;
  padding: 0px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/EndYearAdj/BasicDeclaration.vue